import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import LearningStreamReaderForm from '../forms/learning-stream-reader-form';
import { learningStreamReaderValidationSchema } from '../schema/learningStreamReader.js';

export default function LearningStreamReaderNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Learning Stream Reader Node Details',
        altText: 'Learning Stream Reader Node',
        defaultLabel: 'Learning Stream Reader Node',
      }}
    >
      <CommonNode
        FormComponent={LearningStreamReaderForm}
        schemaResolver={learningStreamReaderValidationSchema}
      />
    </NodeProvider>
  );
}
